import InvitationLinkModal from './InvitationLinkModal';

export default InvitationLinkModal;
